
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

interface ICategory {
  code: string,
  heroTitle?: string,
  image?: string,
  title: string,
  url: string,
  parentId?: string,
  navigationIcon?: string
}

@Component({
  template: `
    <div>
      <div class='navigation-container mb-2'>
        <template v-for="category in levelOne">
          <a
            :href="category.url"
            class="flex flex-align-center link category-link"
            :class="{active: isActive(category.url)}"
            :title="determinTitle(category)">
            <div v-if="getStyle(category)" class="category-icon" :class='getCssClasses(category, true)' :style="getStyle(category)"></div>
            <div class="category-title bold" :class='{"primary--text": isActive(category.url), "gray4--text": !isActive(category.url), "ml-1": !getStyle(category)}'>
              {{ determinTitle(category) }}
            </div>
          </a>
        </template>
         <template v-for="categoryTwo in levelTwoToShow">
            <a
              :href="categoryTwo.url"
              class="flex flex-align-center subcategory"
              :class="{active: isActive(categoryTwo.url)}"
              :title="determinTitle(categoryTwo)">
              <div class="category-title" :class='{"primary--text": isActive(categoryTwo.url), "gray4--text": !isActive(categoryTwo.url)}'>
                {{ determinTitle(categoryTwo) }}
              </div>
            </a>
            <template v-for="categoryThree in levelThreeToShow">
              <a v-if='categoryThree.parentId.indexOf(categoryTwo.code) > -1'
                :class="{active: isActive(categoryThree.url)}"
                :href="categoryThree.url"
                class="flex flex-align-center subcategory"
                :title="determinTitle(categoryThree)">
                <div class="level-three flex flex-align-center" :class='{"primary--text": isActive(categoryThree.url), "gray4--text": !isActive(categoryThree.url)}'>
                  <div class="category-title">{{ determinTitle(categoryThree) }}</div>
                </div>
              </a>
            </template>
          </template>
      </div>

      <h4 class='mb-05 ml-05'>{{title}}</h4>
      <div class="navigation-container">
        <a v-for="category in categoriesToShow"
           v-if="!isActiveOrParent(category.url)"
           :href="category.url"
           class="flex flex-align-center link category-link"
           :title="determinTitle(category)">
          <div v-if="getStyle(category)" class="category-icon gray3" :class="getCssClasses(category, false)" :style="getStyle(category)"></div>
          <div class="category-title bold gray3--text" :class='{"ml-1": !getStyle(category)}'>
            {{ determinTitle(category) }}
          </div>
        </a>
      </div>
    </div>
  `
})
export default class CategoryNavigation extends Mixin {
  @Prop() categories!: any
  @Prop() levelOne: ICategory[]
  @Prop() levelTwo!: any
  @Prop() levelThree!: any
  @Prop() isActiveOrParent!: Function
  @Prop() isActive!: Function
  @Prop({ default: 'Andere top categorieen'}) title: string

  categoriesToShow = []
  levelTwoToShow = []
  levelThreeToShow = []

  created() {
    this.categoriesToShow = this.categories.toSorted((a: any, b: any) => b.priority - a.priority)
    this.levelTwoToShow = this.levelTwo.toSorted((a: any, b: any) => b.priority - a.priority)
    this.levelThreeToShow = this.levelThree.toSorted((a: any, b: any) => b.priority - a.priority)
  }

  getCssClasses(category: ICategory, addColor: boolean): string {
    let result = ''
    if(addColor) result += ' ' + (this.isActive(category.url)? 'primary' : 'gray4')

    return result
  }

  getStyle(category: ICategory){
    const icon =  category.navigationIcon ?  category.navigationIcon: '';
    let result = '';
    if(icon){
      result =  `-webkit-mask-image: url('/themes/assets/static/category-icons/${icon}.svg');mask-image: url('/themes/assets/static/category-icons/${icon}.svg');`
    }

    return result
  }

  determinTitle(category: ICategory): string {
    return category.heroTitle ? category.heroTitle : category.title
  }

}
